module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("In a Million Years –"), _c('br'), _vm._v(" Evolution-Omnipotence")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#chapter-1-vians-uploads"
    }
  }, [_vm._v("Chapter 1: Vian’s Uploads")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#chapter-2-vians-birthday-and-the-history-of-humanity"
    }
  }, [_vm._v("Chapter 2: Vian’s Birthday and the History of Humanity")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#chapter-3-the-immortality-claim"
    }
  }, [_vm._v("Chapter 3: The Immortality Claim")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#chapter-4-the-queens-speech"
    }
  }, [_vm._v("Chapter 4: The Queen’s Speech")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#chapter-5-vian-the-queens-assistant",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: Vian; The Queen’s Assistant")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#chapter-6-her-majestys-domain-and-a-breakfast",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Her Majesty’s Domain and a Breakfast")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#chapter-7-the-step",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: The Step")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#chapter-8-almost-a-fatal-mistake",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: Almost a Fatal Mistake")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#chapter-9-a-million-years-ago-the-story-of-planet-earth",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: A Million Years Ago; The Story of Planet Earth")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#chapter-10-omniris-the-horror-game",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: Omniris, the Horror Game")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#chapter-11-new-horizons",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: New Horizons")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#chapter-12-keeper-clarice",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: Keeper Clarice")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#chapter-13-the-generals",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: The Generals")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#chapter-14-the-meeting-the-mission",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: The Meeting; The Mission")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#chapter-15-the-new-ruler-of-takara",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: The New Ruler of Takara")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#chapter-16-fear-the-unknown-and-the-unexpected",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16: Fear the Unknown and the Unexpected")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#chapter-17-a-visit-home",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17: A Visit Home")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#chapter-18-second-encounter",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18: Second Encounter")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#chapter-19-the-abragar-family",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19: The Abragar Family")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#chapter-20-data-extraction",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20: Data Extraction")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#chapter-21-rogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21: Rogue")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#chapter-22-siblings",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22: Siblings")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#chapter-23-the-white-general",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23: The White General")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#chapter-24-the-shadows-wake",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24: The Shadows Wake")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#about-the-author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#acknowledgement",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgement")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-246b895e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0